import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelToNormal',
  standalone: false,
})
export class CamelToNormalPipe implements PipeTransform {
  transform(camelString: string): string {
    if (!camelString) return camelString;
    // already a readable sentence (e.g. "Published BtB packs ...") – leave as is
    if (/\s/.test(camelString)) return camelString;
    return camelString
      .replace(/([a-z])([A-Z])/g, '$1 $2')
      .replace(/^[a-z]/, (char) => char.toUpperCase());
  }
}
